import React from "react";
import {Col} from 'react-bootstrap';

function STCCol(props){
    return(
        <Col

            style={props.style}
            className={props.className}
            align={props.align}
            id={props.id}

            as={props.as}
            lg={props.lg}
            md={props.md}
            sm={props.sm}
            xl={props.xl}
            xs={props.xs}
            xxl={props.xxl}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Col>
    )
}
export default STCCol;